'use client';

import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

import { EmptySelect } from '@/components/selectors/emptySelect';
import { useDAL } from '@/contexts/useDAL';

export const AzureVnetSelect = ({
  accountId,
  resourceGroup,
  location,
  vnetName,
  onChange,
}: {
  accountId: string;
  resourceGroup?: string;
  location?: string;
  vnetName?: string;
  onChange: (value: string | undefined) => void;
}) => {
  if (!resourceGroup) {
    return <EmptySelect title='VNet' />;
  }

  return (
    <InnerAzureVnetSelect
      accountId={accountId}
      resourceGroup={resourceGroup}
      location={location}
      vnetName={vnetName}
      onChange={onChange}
    />
  );
};

const InnerAzureVnetSelect = ({
  accountId,
  resourceGroup,
  location,
  vnetName,
  onChange,
}: {
  accountId: string;
  resourceGroup: string;
  location?: string;
  vnetName?: string;
  onChange: (value: string | undefined) => void;
}) => {
  const dal = useDAL();
  const { data: vnets } = dal.restore.azureRestoreConfig.useListVirtualNetworks(
    accountId,
    resourceGroup,
    location
  );

  const options = vnets?.virtualNetworks.map((vnet) => vnet.name) ?? [];

  return (
    <FormControl size='small' fullWidth>
      <FormLabel>VNet</FormLabel>
      <Autocomplete
        size='small'
        value={vnetName || null}
        onChange={(_, newValue) => onChange(newValue || undefined)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder='Select VNet'
            label=''
            slotProps={{ inputLabel: { shrink: true } }}
          />
        )}
        options={options}
      />
    </FormControl>
  );
};
